import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CategoryFilter extends Component {
    state = {
         categoryLists:[],
         categoryValue:''
    };
    componentDidMount(){
        this._getCategory(this.props.start_date,this.props.end_date);
    }

    resetCategoryFilter(){
        this.setState({
        categoryValue: [],
        })
    }
    _getCategory(start_date, end_date){

        this.setState({
             categoryLists:[],
              categoryValue:[]

        })
        axios.post(config.get('API_URL')+'/reports/emi-debit-card-category/',{

                      yestSend:start_date,
                      todSend:end_date,
                 },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.setState({
                categoryLists:[]
            })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((category, index) => {
                    this.state.categoryLists.push({value: category.category, label: category.category})

                });
            }
         });
    }

    changeCategory(optionSelected){
        let value='';
        let catArray = [];
        if(optionSelected.length < 1){
            value = null;
            catArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                catArray.push(mids.value)
                var index = this.state.categoryLists.findIndex(obj => obj.value==mids.value);
                this.state.categoryLists.move(index,0).join(',');
            });
        }
        this.props.onSelectCategory(optionSelected,catArray);
        this.setState({
            categoryValue:optionSelected,
        });
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="category"
                isMulti
                value={this.state.categoryValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeCategory.bind(this)}
                options={this.state.categoryLists}
                placeholderButtonLabel="Select [Category]"
            />
        );

    }
}
export default CategoryFilter;